<template>
    <div id="additionals-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Доборные элементы</div>
        <div class="sidebar-text-area">Чтобы добавить на сцену доборный элемент, поставьте в рабочей области <span class="red-text bold-text">две точки</span> так так, чтобы ограниченный данными точками отрезок образовывал
            <span class="red-text bold-text">сторону</span> будущего доборного элемента, как показано на рисунке.</div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/additionals_tip_1.png')"/>
        </div>
        <div class="sidebar-text-area">После построения отрезка - в рабочей области появится <span class="red-text bold-text">фигура</span> - плоскость доборного элемента и две направляющие линий. <span class="red-text bold-text">Перемещая точки</span> фигуры можно корректировать геометрию доборного элемента.</div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/additionals_tip_2.png')"/>
        </div>
    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";

    export default {
        name: "AdditionalsSidebarMenu",
        mixins: [urlForStaticVue]
    }
</script>

<style scoped>

</style>
